import { ref, watch } from 'vue-demi';
import { use } from '@fegobull/webapi';
import { Channel } from './type';
const { useVariable } = use;
let data = null;
if (useVariable) {
    data = useVariable();
}

export const code = ref('{code}');
export const inviteLink = ref('{inviteLink}');
export const appDataList = ref([]);

// 首字母转大写
function capitalizeFirstLetter(str) {
    if (!str || str.length === 0) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * 获取邀请码和邀请链接
 * @param {string} channel 渠道
 */
const fegoVarPrefix = 'inviteGuide';
function getAppData(channel) {
    let globalCodeKey = 'code';
    let globalInviteLinkKey = 'inviteLink';
    let fegoCodeKey = `${fegoVarPrefix}Code`;
    let fegoInviteLinkKey = `${fegoVarPrefix}InviteLink`;
    if (channel) {
        globalCodeKey = `${channel}Code`;
        globalInviteLinkKey = `${channel}InviteLink`;
        fegoCodeKey = `${fegoVarPrefix}${capitalizeFirstLetter(channel)}Code`;
        fegoInviteLinkKey = `${fegoVarPrefix}${capitalizeFirstLetter(channel)}InviteLink`;
    }
    return {
        code: window?._params?.payload?.[globalCodeKey] || data?.[fegoCodeKey] || '',
        inviteLink: window?._params?.payload?.[globalInviteLinkKey] || data?.[fegoInviteLinkKey] || ''
    };
}

if (!window.FEGOEditor) {
    watch(
        () => [data?.inviteGuideCode, data?.inviteGuideInviteLink],
        () => {
            code.value = getAppData().code;
            inviteLink.value = getAppData().inviteLink;
            appDataList.value = [
                {
                    channel: Channel.SYSTEM,
                    ...getAppData()
                },
                {
                    channel: Channel.REDDIT,
                    ...getAppData(Channel.REDDIT)
                },
                {
                    channel: Channel.FACEBOOK,
                    ...getAppData(Channel.FACEBOOK)
                },
                {
                    channel: Channel.TELEGRAM,
                    ...getAppData(Channel.TELEGRAM)
                },
                {
                    channel: Channel.XIAOHONGSHU,
                    ...getAppData(Channel.XIAOHONGSHU)
                },
                {
                    channel: Channel.TWITTER,
                    ...getAppData(Channel.TWITTER)
                },
                {
                    channel: Channel.INSTAGRAM,
                    ...getAppData(Channel.INSTAGRAM)
                }
            ];
        },
        {
            immediate: true
        }
    );
}
